var _defs, _path, _path2, _path3, _path4, _g, _g2, _g3, _g4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProgramEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 112.608,
    height: 112.608,
    viewBox: "0 0 112.608 112.608",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1c1c1c"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3282",
    "data-name": "Rectangle 3282",
    width: 8.276,
    height: 8.276,
    transform: "translate(0 0)",
    fill: "#1c1c1c"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_35654",
    "data-name": "Group 35654",
    transform: "translate(-384.079 -157.097) rotate(-45)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35654-2",
    "data-name": "Group 35654",
    transform: "translate(100.5 442.669)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_13",
    "data-name": "Subtraction 13",
    d: "M31.963,39.252H19.626a19.631,19.631,0,0,1-7.64-37.709A19.5,19.5,0,0,1,19.626,0H31.963A19.631,19.631,0,0,1,39.6,37.709,19.5,19.5,0,0,1,31.963,39.252Zm-11.776-28.6a8.972,8.972,0,1,0,0,17.943H31.4a8.972,8.972,0,1,0,0-17.943Z",
    transform: "translate(0 0)",
    fill: "#fc3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_14",
    "data-name": "Subtraction 14",
    d: "M31.963,39.252H19.626a19.631,19.631,0,0,1-7.64-37.709A19.5,19.5,0,0,1,19.626,0H31.963A19.631,19.631,0,0,1,39.6,37.709,19.5,19.5,0,0,1,31.963,39.252Zm-11.776-28.6a8.972,8.972,0,1,0,0,17.943H31.4a8.972,8.972,0,1,0,0-17.943Z",
    transform: "translate(68.411 0)",
    fill: "#fc3"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_16",
    "data-name": "Subtraction 16",
    d: "M31.963,39.252H19.626a19.631,19.631,0,0,1-7.64-37.709A19.5,19.5,0,0,1,19.626,0H31.963A19.631,19.631,0,0,1,39.6,37.709,19.5,19.5,0,0,1,31.963,39.252Zm-11.776-28.6a8.972,8.972,0,1,0,0,17.943H31.4a8.972,8.972,0,1,0,0-17.943Z",
    transform: "translate(68.411 0)",
    fill: "url(#linear-gradient)",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_5617",
    "data-name": "Rectangle 5617",
    d: "M0,0H19.065a8.972,8.972,0,0,1,8.972,8.972v0a8.972,8.972,0,0,1-8.972,8.972H0a0,0,0,0,1,0,0V0A0,0,0,0,1,0,0Z",
    transform: "translate(62.804 10.654)",
    fill: "#fc3"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_15",
    "data-name": "Subtraction 15",
    d: "M31.963,39.252H19.626a19.631,19.631,0,0,1-7.64-37.709A19.5,19.5,0,0,1,19.626,0H31.963A19.631,19.631,0,0,1,39.6,37.709,19.5,19.5,0,0,1,31.963,39.252Zm-11.776-28.6a8.972,8.972,0,1,0,0,17.943H31.4a8.972,8.972,0,1,0,0-17.943Z",
    transform: "translate(0 0)",
    fill: "url(#linear-gradient)",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_5616",
    "data-name": "Rectangle 5616",
    d: "M8.972,0H28.037a0,0,0,0,1,0,0V17.944a0,0,0,0,1,0,0H8.972A8.972,8.972,0,0,1,0,8.972v0A8.972,8.972,0,0,1,8.972,0Z",
    transform: "translate(29.159 10.654)",
    fill: "#fc3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_28856",
    "data-name": "Group 28856",
    transform: "translate(147.741 426.378)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28771",
    "data-name": "Group 28771",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38102",
    "data-name": "Path 38102",
    d: "M5.533,3.025l2.445.715a.415.415,0,0,1,0,.8l-2.445.715a.415.415,0,0,0-.282.282L4.536,7.977a.415.415,0,0,1-.8,0L3.026,5.532a.415.415,0,0,0-.282-.282L.3,4.536a.415.415,0,0,1,0-.8l2.445-.715a.415.415,0,0,0,.282-.282L3.741.3a.415.415,0,0,1,.8,0l.715,2.445a.415.415,0,0,0,.282.282",
    transform: "translate(-0.001 0)",
    fill: "#1c1c1c"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_28977",
    "data-name": "Group 28977",
    transform: "translate(164.332 434.654)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28771-2",
    "data-name": "Group 28771",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38102-2",
    "data-name": "Path 38102",
    d: "M5.533,3.025l2.445.715a.415.415,0,0,1,0,.8l-2.445.715a.415.415,0,0,0-.282.282L4.536,7.977a.415.415,0,0,1-.8,0L3.026,5.532a.415.415,0,0,0-.282-.282L.3,4.536a.415.415,0,0,1,0-.8l2.445-.715a.415.415,0,0,0,.282-.282L3.741.3a.415.415,0,0,1,.8,0l.715,2.445a.415.415,0,0,0,.282.282",
    transform: "translate(-0.001 0)",
    fill: "#1c1c1c"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_35656",
    "data-name": "Group 35656",
    transform: "translate(147.741 481.921)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28771-3",
    "data-name": "Group 28771",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38102-3",
    "data-name": "Path 38102",
    d: "M5.533,3.025l2.445.715a.415.415,0,0,1,0,.8l-2.445.715a.415.415,0,0,0-.282.282L4.536,7.977a.415.415,0,0,1-.8,0L3.026,5.532a.415.415,0,0,0-.282-.282L.3,4.536a.415.415,0,0,1,0-.8l2.445-.715a.415.415,0,0,0,.282-.282L3.741.3a.415.415,0,0,1,.8,0l.715,2.445a.415.415,0,0,0,.282.282",
    transform: "translate(-0.001 0)",
    fill: "#1c1c1c"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_35657",
    "data-name": "Group 35657",
    transform: "translate(164.332 490.197)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28771-4",
    "data-name": "Group 28771",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38102-4",
    "data-name": "Path 38102",
    d: "M5.533,3.025l2.445.715a.415.415,0,0,1,0,.8l-2.445.715a.415.415,0,0,0-.282.282L4.536,7.977a.415.415,0,0,1-.8,0L3.026,5.532a.415.415,0,0,0-.282-.282L.3,4.536a.415.415,0,0,1,0-.8l2.445-.715a.415.415,0,0,0,.282-.282L3.741.3a.415.415,0,0,1,.8,0l.715,2.445a.415.415,0,0,0,.282.282",
    transform: "translate(-0.001 0)",
    fill: "#1c1c1c"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgramEmpty);
export default __webpack_public_path__ + "static/media/program-empty.578bc956dd5c084fd4013fec9fd48806.svg";
export { ForwardRef as ReactComponent };